import { useQuery } from '@apollo/client/react'
import {
  PortalBusinessBalanceDocument,
  type PortalBusinessBalanceQuery,
} from '@/graphql/generated/graphql'

export type BusinessBalance = PortalBusinessBalanceQuery['portalBusinessBalance']

/** Balance de créditos/recargas del negocio elegido. */
export function useBusinessBalance(businessId: string | undefined) {
  const { data, loading, error, refetch } = useQuery(PortalBusinessBalanceDocument, {
    variables: { businessId: businessId ?? '' },
    skip: !businessId,
    fetchPolicy: 'cache-first',
    notifyOnNetworkStatusChange: true,
  })

  return {
    balance: data?.portalBusinessBalance ?? null,
    loading,
    error,
    refetch,
  }
}
